import script from "./SentimentSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SentimentSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SentimentSwitcher.vue?vue&type=style&index=0&id=1dc394d6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc394d6"]])

export default __exports__